import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '@/components/ui/card';

const TermsOfUse = () => {
  return (
    <Card className="glass-effect">
      <CardHeader>
        <CardTitle>Termos de Uso</CardTitle>
        <CardDescription>
          Vigente a partir de 12 de julho de 2026 &mdash; Versão 2.0
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6 text-sm sm:text-base leading-relaxed text-white/90">
          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">1. Aceitação dos Termos</h2>
            <p>
              Ao acessar e utilizar o Sistema Conciliador de Cartões (doravante &quot;Sistema&quot;), operado pela
              Confere Cartão, você (doravante &quot;Usuário&quot;) concorda em cumprir e estar vinculado aos termos e
              condições aqui estabelecidos. Caso não concorde com qualquer parte destes termos, não utilize o Sistema.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">2. Descrição do Serviço</h2>
            <p>
              O Sistema Conciliador de Cartões é uma plataforma web que permite gerenciar e conciliar vendas,
              recebimentos e efetuar conciliação bancária por meio do envio e processamento de arquivos.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">3. Acesso e Licença de Uso</h2>
            <div className="space-y-2">
              <h3 className="font-semibold text-white/95">3.1. Licença de uso</h3>
              <p>
                O acesso ao Sistema é liberado mediante pagamento de taxa correspondente ao plano contratado (mensal, semestral ou anual). O período de uso será válido de acordo com o plano escolhido, a partir da confirmação do pagamento e ativação da conta.
              </p>
            </div>
            <div className="space-y-2">
              <h3 className="font-semibold text-white/95">3.2. Expiração e renovação</h3>
              <p>
                Após o término do período contratado (mensal, semestral ou anual), o acesso expira automaticamente. Para continuar utilizando o Sistema, um novo pagamento deverá ser realizado. Notificaremos o Usuário com antecedência sobre a expiração.
              </p>
            </div>
            <div className="space-y-2">
              <h3 className="font-semibold text-white/95">3.3. Período de teste gratuito</h3>
              <p>
                O Usuário poderá testar o Sistema gratuitamente, mediante acordo com a equipe de suporte. O período e
                as condições do teste serão definidos em conjunto e não garantem acesso permanente sem contratação.
              </p>
            </div>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">4. Responsabilidade do Usuário</h2>
            <div className="space-y-2">
              <h3 className="font-semibold text-white/95">4.1. Veracidade das informações</h3>
              <p>
                O Usuário é integralmente responsável por todas as informações inseridas no Sistema, devendo garantir
                que sejam verdadeiras, precisas, atualizadas e completas.
              </p>
            </div>
            <div className="space-y-2">
              <h3 className="font-semibold text-white/95">4.2. Qualidade dos dados</h3>
              <p>
                Dados incorretos, incompletos ou mal formatados resultarão em conciliações equivocadas. A Confere Cartão
                não se responsabiliza por discrepâncias decorrentes de dados fornecidos pelo Usuário.
              </p>
            </div>
            <div className="space-y-2">
              <h3 className="font-semibold text-white/95">4.3. Uso adequado</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>Utilizar o Sistema apenas para fins legítimos e conforme a legislação vigente;</li>
                <li>Não tentar acessar áreas restritas ou realizar engenharia reversa;</li>
                <li>Não usar o Sistema para atividades ilegais ou fraudulentas;</li>
                <li>Não compartilhar credenciais de acesso com terceiros;</li>
                <li>Manter a segurança de suas credenciais e dispositivos.</li>
              </ul>
            </div>
            <div className="space-y-2 mt-4">
              <h3 className="font-semibold text-white/95">4.4. Criação e Gerenciamento de Subcontas</h3>
              <p>
                O Usuário titular poderá, conforme o plano contratado, criar e gerenciar Subcontas vinculadas ao seu login.
                O Usuário titular é o **único responsável legal e financeiro** por todas as suas Subcontas. Qualquer violação 
                cometida em uma Subconta resultará em penalidades para a conta titular, incluindo possível suspensão de acesso.
              </p>
            </div>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">5. Limitação de Responsabilidade</h2>
            <div className="space-y-2">
              <h3 className="font-semibold text-white/95">5.1. Disponibilidade do serviço</h3>
              <p>
                Buscamos manter o Sistema disponível 24/7, mas interrupções podem ocorrer por manutenção, falha técnica,
                atos de terceiros ou força maior. A Confere Cartão não responde por danos decorrentes de indisponibilidade.
              </p>
            </div>
            <div className="space-y-2">
              <h3 className="font-semibold text-white/95">5.2. Resultados e conciliações</h3>
              <p>
                Os resultados dependem das informações fornecidas pelo Usuário. Não garantimos precisão absoluta,
                completude, ausência de erros ou compatibilidade com todos os formatos de arquivo.
              </p>
            </div>
            <div className="space-y-2">
              <h3 className="font-semibold text-white/95">5.3. Limitação geral</h3>
              <p>
                Na máxima extensão permitida por lei, a Confere Cartão não será responsável por danos diretos, indiretos,
                incidentais, consequenciais ou punitivos, nem por perdas de lucros, dados ou oportunidades de negócio.
              </p>
            </div>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">6. Propriedade Intelectual</h2>
            <p>
              O Sistema, incluindo código-fonte, design, funcionalidades, logotipos e marca &quot;Confere Cartão&quot;,
              é propriedade exclusiva da Confere Cartão e protegido por leis de direitos autorais e marcas.
              Concedemos uma licença limitada, não exclusiva e revogável para uso durante a vigência da assinatura.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">7. Pagamento e Renovação</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                <span className="font-semibold text-white/95">Taxa do plano:</span> o valor aplicável ao período contratado (mensal, semestral ou anual) é informado no ato da
                contratação e pode ser reajustado com aviso prévio de 30 dias.
              </li>
              <li>
                <span className="font-semibold text-white/95">Subcontas:</span> Caso o Usuário possua Subcontas, cada uma delas 
                possui seu próprio ciclo de faturamento e vencimento independente da conta principal (salvo se os vencimentos 
                forem unificados previamente junto ao administrador do sistema).
              </li>
              <li>
                <span className="font-semibold text-white/95">Métodos de pagamento:</span> conforme opções disponibilizadas no momento da contratação.
              </li>
              <li>
                <span className="font-semibold text-white/95">Não reembolso:</span> os valores pagos não são
                reembolsáveis, salvo hipóteses legais ou acordo específico.
              </li>
              <li>
                <span className="font-semibold text-white/95">Renovação:</span> não é automática. O Usuário pode renovar
                após receber o aviso de expiração.
              </li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">8. Suspensão, Exclusão Automática e Encerramento</h2>
            <p>
              A Confere Cartão pode suspender ou encerrar o acesso em caso de violação dos termos, suspeita de fraude,
              inadimplência ou ordem de autoridade.
            </p>
            <p>
              <span className="font-semibold text-white/95">Aviso de Exclusão por Inatividade:</span> Contas ou subcontas que permanecerem 
              com assinatura bloqueada/vencida por um período superior a **3 meses (90 dias)** serão deletadas automaticamente e definitivamente do 
              sistema, apagando todos os dados de vendas, recebimentos e operadoras. O Usuário receberá alertas prévios na tela do sistema.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">9. Alterações nos Termos</h2>
            <p>
              Podemos atualizar este documento a qualquer momento. Mudanças relevantes serão comunicadas com, no mínimo,
              30 dias de antecedência. O uso contínuo do Sistema após a atualização implica aceitação dos novos termos.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">10. Suporte e Contato</h2>
            <p>
              Em caso de dúvidas, sugestões ou problemas técnicos, fale conosco pelo e-mail{' '}
              <a href="mailto:contato@conferecartao.com.br" className="text-primary font-semibold">
                contato@conferecartao.com.br
              </a>
              . Nosso time se esforça para responder em até 48 horas úteis.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">11. Lei Aplicável e Foro</h2>
            <p>
              Estes Termos são regidos pela legislação brasileira. Fica eleito o foro da comarca de Montanha/ES para
              dirimir quaisquer controvérsias, renunciando as partes a qualquer outro, por mais privilegiado que seja.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">12. Disposições Gerais</h2>
            <p>
              Este documento constitui o acordo integral entre Usuário e Confere Cartão acerca do uso do Sistema.
              Caso qualquer cláusula seja considerada inválida, as demais permanecerão produzindo efeitos. A não
              exigência de cumprimento de qualquer cláusula não implica renúncia de direito.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-white">13. Aceitação</h2>
            <p>
              Ao utilizar o Sistema, o Usuário declara ter lido, compreendido e concordado com todas as condições deste
              Termo de Uso.
            </p>
          </section>

          <section className="space-y-1 text-sm text-white/80">
            <p><span className="font-semibold text-white">Confere Cartão</span></p>
            <p>Última atualização: 12 de julho de 2026</p>
            <p>Contato: contato@conferecartao.com.br</p>
          </section>
        </div>
      </CardContent>
    </Card>
  );
};

export default TermsOfUse;

